export default __webpack_public_path__ + "static/media/cleanpro_laundrypass.9b2c42cc.jpeg";